export default class Deal {
   constructor(bxItem) {
      if (!bxItem) return;

      this.id = bxItem.ID;
      this.contactId = bxItem.CONTACT_ID;
      this.leadId = bxItem.LEAD_ID;
      this.contact = null;
      this.lead = null;

      this.typeId = bxItem.TYPE_ID;
   }

   get contactType() {
      if (this.contact) {
         return this.contact.type
      } else if (this.lead) {
         return this.lead.type
      }
      return ''
   }

   get name() {
      if (this.contact) {
         return this.contact.name
      }
      return ''
   }

   get fio() {
      if (this.contact) {
         return this.contact.resident
      }
      return ''
   }

   get resident() {
      if (this.contact) {
         return this.contact.crp
      }
      return []
   }

   get ogrn() {
      if (this.contact) {
         return this.contact.ogrnIP
      }
      return ''
   }

   get phone() {
      if (this.contact) {
         return this.contact.phone
      }
      return ''
   }

   get email() {
      if (this.contact) {
         return this.contact.email
      }
      return ''
   }

   get regDate() {
      if (this.contact && !isNaN(this.contact.regDate)) {
         return this.contact.regDate
      }
      return ''
   }

   get service() {
      switch(this.typeId) {
         case 'SALE': return 'dealType.consult';
         case 'COMPLEX': return 'dealType.placement';
         case '1': return 'dealType.juridical';
         case '2': return 'dealType.accounting';
         case '3': return 'dealType.create';
         case '4': return 'dealType.license';
         case '5': return 'dealType.loan';
         case '6': return 'dealType.register';
         case '7': return 'dealType.promo';
         default: return ''
      }
   }

   get inn() {
      if (this.contact) {
         return this.contact.inn || ''
      }
      return ''
   }
}